import { useRadio, Box, UseRadioProps, HStack, useRadioGroup } from "@chakra-ui/react";
import { ReactNode } from "react";

interface RadioCardProps extends UseRadioProps{
    children?: ReactNode;
};

type RadioGroupProps = {
    selectedValue?: string;
    options: {
      name: string;
      value: string | number;
      disabled?: boolean;
    }[];
    onChange: (eventOrValue: React.ChangeEvent<HTMLInputElement> | string | number) => void;
};

const RadioCard = (props: RadioCardProps) => {
    const { getInputProps, getCheckboxProps } = useRadio(props)
  
    const input = getInputProps()
    const checkbox = getCheckboxProps()
  
    return (
      <Box as='label'>
        <input {...input} />
        <Box
          {...checkbox}
          cursor='pointer'
          borderWidth='1px'
          borderRadius='20px'
          boxShadow='md'
          _checked={{
            bg: 'white',
            color: 'black',
            border: '1px'
          }}
          _focus={{
            boxShadow: 'outline',
          }}
          px={3}
          py={2}
          width="max-content"
        >
          {props.children}
        </Box>
      </Box>
    )
  }

  const RadioGroup = (props: RadioGroupProps) => {  
    const { getRootProps, getRadioProps } = useRadioGroup({
      name: 'framework',
      defaultValue: 'react',
      onChange: props.onChange,
    })
  
    const group = getRootProps()
  
    return (
      <HStack {...group}>
        {props.options.map((option) => {
          const radio = getRadioProps({ value: option.value })
          return (
            <RadioCard  key={option.value} {...radio}>
              {option.name}
            </RadioCard>
          )
        })}
      </HStack>
    )
  }

  export { RadioGroup };